<template>
  <div id="StudyTravelGuide" class="study">
    <div class="container-fluid head" style="background-color: #174064">
      <Header />
      
      <h1>Travel Guide</h1>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-12">
          <p>
            This is a personal project to design a travel guide for Peru where I designed a layout, worked with grids, typefaces and edited pictures.
            I used InDesign for the layout and Photoshop to edit the pictures.
            These photographs are from my own visits and I used different travel agencies websites from Peru and blogs to get all the information.<br/>
            Written, designed and photographed by me.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-12 text-center">
          <br />
          <br />
          <img src="/images/TravelGuide/1.webp" width="100%" />
          <img src="/images/TravelGuide/2.webp" width="50%" class="mt-5" />
          <img src="/images/TravelGuide/3.webp" width="100%" class="mt-5" />
          <img src="/images/TravelGuide/4.webp" width="100%" class="mt-5" />
          <img src="/images/TravelGuide/5.webp" width="100%" class="mt-5" />
          <img src="/images/TravelGuide/6.webp" width="100%" class="mt-5" />
          <img src="/images/TravelGuide/7.webp" width="100%" class="mt-5" />
          <img src="/images/TravelGuide/8.webp" width="100%" class="mt-5" />
          <img src="/images/TravelGuide/9.webp" width="100%" class="mt-5" />
          <img src="/images/TravelGuide/10.webp" width="100%" class="mt-5" />
          <img src="/images/TravelGuide/11.webp" width="50%" class="mt-5" />
        </div>
      </div>

    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
export default {
  name: "StudyTravelGuide",
  components: { Header, Footer },
  data: function () {
    return {
      slides: [],
    };
  },
  methods: {},
  mounted: function () {},
};
</script>

<style lang="scss">
#StudyTravelGuide {
  h2 {
    color: #439ad0;
  }
}
</style>